import { Type } from "@shared/ui/Type";
import { OuterContentContainer } from "@shared/ui/OuterContentContainer";

type MarketingSectionProps = {
  children: React.ReactNode;
  id?: string;
  title?: string;
};

export function MarketingSection({
  children,
  id,
  title,
}: MarketingSectionProps) {
  return (
    <OuterContentContainer as="section" id={id}>
      <div className="flex flex-col gap-8 w-full">
        {title && (
          <Type as="h2" variant="h2">
            {title}
          </Type>
        )}
        {children}
      </div>
    </OuterContentContainer>
  );
}

export default MarketingSection;
